import { useLayoutEffect } from 'react';

import {
  ForbiddenErrorPage,
  InternalServerErrorPage,
} from '@mint-lib/error-boundary';

type Props = Readonly<{
  error: any;
}>;
const FORBIDDEN_STATUS = 403;

export default function ErrorComponent({ error }: Props) {
  useLayoutEffect(() => {
    console.error('router', error);
    // TODO: remove after cloudfront
    if (
      error.message?.includes('Failed to fetch dynamically imported module')
    ) {
      globalThis.location.reload();
      return;
    }
  }, [error]);

  if (error.message?.includes('Failed to fetch dynamically imported module')) {
    return <div />;
  }

  if (error.status === FORBIDDEN_STATUS) {
    return <ForbiddenErrorPage />;
  }

  // @ts-expect-error - error is not typed
  return <InternalServerErrorPage error={error} />;
}
